import React from 'react';
import { connect } from 'react-redux';

import { Select } from 'redpoints-front-components/index';

import { auditResultsSetSelectedAuditorAssetId } from '../../../actions/auditResultsActions';
import {
  getAuditResultsAuditorAssets,
  getAuditResultsAuditorAssetsIsLoading,
  getAuditResultsSelectedAuditorAssetId,
} from '../../../reducers/assetAudit/auditResults';
import { translate } from '../../../helpers/languageHelper';

const AuditResultsFiltersAuditorAsset = ({
  assetSelected,
  auditAssets,
  auditResultsSetSelectedAuditorAssetId,
  isLoadingAuditorAssets,
}) => {
  const handleOnChange = assetId => {
    auditResultsSetSelectedAuditorAssetId({ assetId });
  };
  return (
    <Select
      allowClear
      data={auditAssets}
      disabled={isLoadingAuditorAssets}
      label={translate('auditResults.filters.asset.label')}
      loading={isLoadingAuditorAssets}
      mapping={{ key: 'assetId', value: 'name' }}
      onChange={handleOnChange}
      placeholder={translate('auditResults.filters.asset.placeholder')}
      value={assetSelected || undefined}
    />
  );
};

const mapStateToProps = state => ({
  auditAssets: getAuditResultsAuditorAssets(state),
  assetSelected: getAuditResultsSelectedAuditorAssetId(state),
  isLoadingAuditorAssets: getAuditResultsAuditorAssetsIsLoading(state),
});

export default connect(mapStateToProps, {
  auditResultsSetSelectedAuditorAssetId,
})(AuditResultsFiltersAuditorAsset);
